import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()((theme) => ({
    flyingCartTotal: {
        paddingBottom: theme.spacing(2),
    },
    flyingCartTotalTitle: {
        color: theme.palette.secondary.main,
        fontWeight: theme.typography.fontWeightRegular,
        fontSize: "18px",
    },
    creditCardIcon: {
        width: 14,
        height: 14,
    },
    refreshIcon: {
        width: 18,
        height: 18,
    },
}));
